module.exports = __webpack_public_path__ + "efa8fd1197b6ae1898f69abd5e8345e3.pdf";